import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface AwardBookRecommendation {
  title: string;
  author: string;
  reason: string;
  match_score: number;
  bookId?: string;
  coverUrl?: string;
  awardName?: string;
  awardYear?: number;
}

export const useAwardBookRecommendations = () => {
  return useQuery({
    queryKey: ['awardBookRecommendations'],
    queryFn: async (): Promise<AwardBookRecommendation[]> => {
      console.log('🏆 Fetching AI award book recommendations...');

      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        throw new Error('Not authenticated');
      }

      const { data, error } = await supabase.functions.invoke('recommend-award-books', {
        body: {},
        headers: {
          Authorization: `Bearer ${session.access_token}`
        }
      });

      if (error) {
        console.error('❌ Error fetching award recommendations:', error);
        throw error;
      }

      if (!data || !data.recommendations) {
        console.warn('⚠️ No recommendations returned');
        return [];
      }

      console.log(`✅ Got ${data.recommendations.length} award book recommendations`);
      return data.recommendations;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 60, // 1 hour
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1
  });
};
